import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {Loner} from "../../Loner";
import {LonerGameMode} from "../../server/LonerGameMode";

/**
 * Created by Jerker Nord on 2022-04-01.
 */

export class LonerTotalWinPresentation implements SimplePresentation {

    private _mainTL: gsap.core.Timeline;
    private _controller: SimplePresentationRunnerController;

    constructor() {
    }

    public shouldRun(): boolean {
        if (Loner.model.data.mode == LonerGameMode.NORMAL) {
            //Only run if NOT big win. Unless it's below stake.
            if (Loner.model.winRatio < this.getBigWinRatio()) {
                return Loner.model.gameData.accumulatedRoundWin > 0;
            } else {
                return (Loner.isWinBelowStake() || Loner.isWinBelowPlayedBetValue())
            }
        }
        return false;
    }

    private getBigWinRatio(): number {
        return 15;
    }

    public start(controller: SimplePresentationRunnerController): void {
        this._controller = controller;
        const delayTL: gsap.core.Timeline = new gsap.core.Timeline({delay: 0.1});
        let winAmount: number = Loner.model.gameData.accumulatedRoundWin;
        if (Loner.model.gameData.brokeTheBank == true) {
            winAmount = Loner.model.upToMaxWinAmount;
        }
        delayTL.add(() => {
            this._mainTL = gsap.timeline({
                onComplete: () => {
                    this.complete();
                }
            });
            this._mainTL.add([
                Loner.totalWinView.getTotalWinTimeline(winAmount),
                () => this._controller.setSkipCallback(() => this.skip())
            ]);
            if (this.isWinBeforeFeature() == true) {
                this._mainTL.add(gsap.timeline({delay: 1}));
                this._mainTL.add(() => {
                    Loner.initialWinView.resetWinContainers()
                });
            } else if (Loner.autoPlayPlugin.isAutoplayRound == true) {
                this._mainTL.add(gsap.timeline({delay: 0.7}));
            }
        });
    }

    private isWinBeforeFeature(): boolean {
        if (Loner.model.mode == LonerGameMode.NORMAL && (Loner.model.nextMode == LonerGameMode.FEATURE_PIN_THE_WIN
            || Loner.model.nextMode == LonerGameMode.FEATURE_TICK_TICK_BOOM || Loner.model.nextMode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK)) {
            return true;
        }
        return false;
    }

    private skip(): void {
        Loner.totalWinView.hardAbort();
    }

    private complete(): void {
        Loner.idleNormal.initialWinDone = true;
        if (Loner.model.winRatio >= 15) {
            Loner.bigWinPresentation.initialWinDone = true;
        }
        this._controller.finish();
    }
}